import React from 'react';
import login from '../../images/login.png'

const Login = () => {


    return (
        <div className="div d-flex justify-content-center align-items-center">
            <img className='w-75' src={login} alt="" />
        </div>
    );
};

export default Login;